import { ValidarCuit } from './form_validation';

const STORAGE_PREFIX = 'wdp:simulation-history:v1:';
const MAX_RECENT = 5;
const storageKey = userId => `${STORAGE_PREFIX}${encodeURIComponent(userId)}`;

function normalize(items) {
    if (!Array.isArray(items)) return [];
    const recent = [];
    for (const item of items) {
        const id = String(item?.id ?? '').replace(/[-\s]/g, '');
        if (!/^\d{11}$/.test(id) || !ValidarCuit(id) || typeof item?.value !== 'string' || !item.value.trim()
            || typeof item.registeredIdentity !== 'boolean' || recent.some(entry => entry.id === id)) continue;
        recent.push({ id, value: item.value.trim(), registeredIdentity: item.registeredIdentity });
        if (recent.length === MAX_RECENT) break;
    }
    return recent;
}

export function readSimulationHistory(userId) {
    if (!userId) return [];
    try { return normalize(JSON.parse(localStorage.getItem(storageKey(userId)))); }
    catch { return []; }
}

export function rememberSimulation(userId, producer) {
    if (!userId) return;
    try {
        const recent = normalize([producer, ...readSimulationHistory(userId)]);
        localStorage.setItem(storageKey(userId), JSON.stringify(recent));
    } catch { /* El historial es opcional y no debe interrumpir una simulación. */ }
}

export function clearSimulationHistory(userId) {
    if (!userId) return false;
    try { localStorage.removeItem(storageKey(userId)); return true; }
    catch { return false; }
}

// Conservar únicamente el historial al limpiar las credenciales y el resto de la sesión.
export function clearLocalStorageExceptSimulationHistory() {
    for (let index = localStorage.length - 1; index >= 0; index--) {
        const key = localStorage.key(index);
        if (!key.startsWith(STORAGE_PREFIX)) localStorage.removeItem(key);
    }
}
